import {Dispatch, GetState, TempThunkAction} from '../app-types';
import {fetchJson} from './fetcher';
import {ContainerLoadAction} from '../settings/duck/settings-actions';
import {setSortSettingsAction, setSearchQueryFieldsAction} from '../search/duck/search-actions';
import {SearchPageType} from '../search/search-config';
import {ContainerAttributes, ContainersResponse} from '../settings/duck/settings-types';
import {SortType} from '../search/search-types';

export const doLoadContainersRequest = (searchPageType: SearchPageType, currentContainer: string): TempThunkAction => {
    return (dispatch: Dispatch, getState: GetState) => {
        const queryFieldsSet = getState().search[searchPageType].queryFields;
        return fetchJson<ContainersResponse>('/settings/container', 'GET')
            .then((containersResponse: ContainersResponse) => {
                dispatch(containerLoadFinishedAction(containersResponse, searchPageType));
                const containerAttributes: ContainerAttributes = containersResponse.containers.filter(
                    ({name}) => name === currentContainer
                )[0];
                const containerQueries: string[] = containerAttributes?.queryFields;
                const sortOptions: SortType[] = containerAttributes?.sortOptions;
                if (!queryFieldsSet) {
                    dispatch(setSearchQueryFieldsAction(searchPageType, containerQueries));
                }
                dispatch(setSortSettingsAction(sortOptions));
            })
            .catch((error) => {
                console.log(error);
            });
    };
};

export const doGetAppVersionsRequest = (callback: (response: ContainersResponse) => void): TempThunkAction => {
    return () => {
        return fetchJson<ContainersResponse>('/info/versions', 'GET')
            .then((response) => {
                callback(response);
            })
            .catch((error) => {
                console.log(error);
            });
    };
};

function containerLoadFinishedAction(
    {containers, defaultContainer}: ContainersResponse,
    searchPageType: SearchPageType
): ContainerLoadAction {
    return {
        type: 'CONTAINER_LOAD_FINISHED',
        containers,
        defaultContainer,
        searchPageType,
    };
}
